/**
 * Resource that represents an User.
 *
 * @name User
 * @class
 * @augments TmrResource
 */
function UserFactory(
  TmrResource,
  TmrApi,
  Place,
  Role,
  TmrTransformResourceAction
) {
  'ngInject'
  let actions = {
    get: {},
    save: {},
    bulkCreate: {},
    bulkUpdate: {},
    query: {},
    search: {},
    getLogged: {
      method: 'GET',
      url: TmrApi.endpoint('loggedUser'),
    },
    updateSelf: {
      method: 'POST',
      url: TmrApi.endpoint('User.self'),
    },
  }

  let defaultValues = () => ({
    data: {},
    roles: [],
    rolesPlaces: [],
  })

  let referencedProperties = [
    // user.place property will be instantiated as a Place resource
    { property: 'place', resource: Place },
    // user.roles property will be instantiated as a Role resource
    { property: 'roles', resource: Role },
    // user.rolesPlaces property will be instantiated as a Place resource
    { property: 'rolesPlaces', resource: Place },
  ]

  for (let name in actions) {
    TmrTransformResourceAction.prependRequest(actions[name], request => {
      Array.isArray(request)
        ? ReplaceProperties(request, 'request')
        : ReplaceProperty(request, 'request')
      return request
    })
    TmrTransformResourceAction.appendResponse(actions[name], response => {
      Array.isArray(response)
        ? ReplaceProperties(response, 'response')
        : ReplaceProperty(response, 'response')
      return response
    })
  }

  /** Call Replaceproperty if resource is an Array */
  function ReplaceProperties(resource, type) {
    resource.forEach(res => ReplaceProperty(res, type))
    return resource
  }

  /** Convert data property request:from JSON to string OR response:from string to JSON */
  function ReplaceProperty(resource, type) {
    if (resource && resource.data !== undefined) {
      resource.data =
        type === 'request'
          ? JSON.stringify(resource.data)
          : JSON.parse(resource.data)
    }
    return resource
  }

  let User = TmrResource('User', actions, referencedProperties, defaultValues)

  Object.assign(User.prototype, {
    /**
     * Override default label property.
     *
     * @method User#$getLabelProperty
     */
    $getLabelProperty: () => 'username',
    /**
     * Returns the formatted full name of the user.
     *
     * @method User#$getFullName
     */
    $getFullName: function (fallback = this.username) {
      return this.name || this.surname
        ? `${this.name ?? ''} ${this.surname ?? ''} `.trim()
        : fallback
    },
    /**
     * Returns user roles sorted by priority (lower comes first; same priority falls back to first created)
     *
     * @method User#$getRoles
     */
    $getRoles: function () {
      return this.roles.sort((a, b) =>
        a.priority == b.priority
          ? a.creationDate - b.creationDate
          : a.priority - b.priority
      )
    },
    /**
     * Returns the user language
     *
     * @method User#$getLanguage
     */
    $getLanguage: function () {
      return this.data?.language
    },
  })

  return User
}

export const factory = ['User', UserFactory]
